import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Reservation } from 'src/app/models/Reservation';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  @Input() isDataLoaded: boolean;
  @Input() tableData: any;
  @Input() tableKeys: any;
  @Input() colTypes: any;
  @Input() tableConfig: any;
  @Input() tableAction: any;
  @Input() tableButtonAction: any;
  @Input() tablePOSAction: any;
  @Input() currentPage: any;
  @Input() pages: any;
  @Input() visiblePages: any;
  @Input() filterForm: any;
  @Input() loggedUserRole: any;
  @Input() filterAvailability: boolean;
  @Input() sortName_asc: boolean;
  @Input() sortName_dsc: boolean;
  @Input() categoryActive: number;
  @Input() categories: any;
  @Input() tableInfo: any;
  @Input() isFilterClicked: any;
  @Input() orderActionFilterSelected: any;
  @Input() oderActionsSelector: any;
  @Input() master_outlet_id: any;
  @Input() filterClickHeight: any;
  @Input() filterNotClickHeight: any;
  @Input() isAllSelected: any;
  @Input() selectedMenuItems: any;
  @Input() noItemsAvailable: any;
  @Input() filterSearchAvailability: any;
  @Input() policies: any;
  @Input() posSyncPolicy: any;
  @Input() access: any;
  @Input() toggleAccess: any;
  @Input() disabledActions: any;
  @Input() centerTableBodyElement: any;
  @Input() placeholderText: any;

  @Output() onEditClick = new EventEmitter<any>();
  @Output() onDeleteClick = new EventEmitter<any>();
  @Output() onViewClick = new EventEmitter<any>();
  @Output() onDuplicateClick = new EventEmitter<any>();
  @Output() onGenerateClick = new EventEmitter<any>();
  @Output() onSetUpClick = new EventEmitter<any>();
  @Output() onMappingClick = new EventEmitter<any>();
  @Output() onCompleteClick = new EventEmitter<any>();
  @Output() onShareClick = new EventEmitter<any>();
  @Output() onDownloadClick = new EventEmitter<any>();
  @Output() getMoreItems = new EventEmitter<any>();
  @Output() refreshFilters = new EventEmitter<any>();
  @Output() showFilter = new EventEmitter<any>();
  @Output() categoryPressed = new EventEmitter<any>();
  @Output() onStateChange = new EventEmitter<any>();
  @Output() searchItems = new EventEmitter<any>();
  @Output() itemSort = new EventEmitter<any>();
  @Output() posActionsClick = new EventEmitter<any>();
  @Output() onChangeSchedule = new EventEmitter<{ int: any; e: any }>();
  @Output() onChangeAccepting = new EventEmitter<{ int: any; e: any }>();
  @Output() onOwnDriverChange = new EventEmitter<{ int: any; e: any }>();
  @Output() onChangeAutoAccepting = new EventEmitter<{ int: any; e: any }>();
  @Output() open = new EventEmitter<{ text: any; id: any }>();
  @Output() checkboxSelector = new EventEmitter<any>();
  @Output() selectItem = new EventEmitter<{ item: any; event: any }>();
  @Output() placeTestOrders = new EventEmitter<{ data: any; }>();
  @Output() onPrepTimeSelect = new EventEmitter<{ time: any; platformData: any; }>();
  @Output() onReservationActionClick = new EventEmitter<{ status: any, data: Reservation }>();

  availableTimes = [
    { id: 0, timeZone: '10 Minutes', value: 10 },
    { id: 1, timeZone: '20 Minutes', value: 20 },
    { id: 2, timeZone: '30 Minutes', value: 30 },
    { id: 3, timeZone: '40 Minutes', value: 40 },
    { id: 4, timeZone: '45 Minutes', value: 45 },
    { id: 5, timeZone: '1 Hour', value: 60 },
  ];

  constructor() { }

  ngOnInit(): void {

  }

  setDisplayId(id: any) {
    let s = id + '';
    while (s.length < 5) s = '0' + s;
    return s;
  }

  setData(data: any) {
  }

  setString(text: any) {
    return text?.slice?.(0, 25);
  }

  onClickAction(type: any, data) {
    console.log(type);

    switch (type) {
      case 'View':
        this.onViewClick.emit(data);
        break;
      case 'Edit':
        this.onEditClick.emit(data);
        break;
      case 'Delete':
        this.onDeleteClick.emit(data);
        break;
      case 'Map':
        this.onMappingClick.emit(data);
        break;
      case 'Complete':
        this.onCompleteClick.emit(data);
        break;
      case 'Share':
        this.onShareClick.emit(data);
        break;
      case 'Download':
        this.onDownloadClick.emit(data);
        break;
      default:
        break;
    }
  }

  onPosActionsClick(data) {
    this.posActionsClick.emit(data);
  }

  getPages(pageNumber: any) {
    this.getMoreItems.emit(pageNumber);
  }

  onRefreshFilters() {
    this.refreshFilters.emit();
  }

  onShowFilter() {
    this.showFilter.emit();
    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }
  }

  onCategoryPressed(id: number) {
    this.categoryPressed.emit(id);

    if (id === 0) {
      this.onStateChange.emit('All');
    } else if (id === 1) {
      this.onStateChange.emit('Match Found');
    } else {
      this.onStateChange.emit('Not Found');
    }
  }

  onSearchItems(event) {
    this.searchItems.emit(event);
  }

  onItemSort() {
    this.itemSort.emit();
  }

  onChangeAccept(key: any, data: any, accept: any) {
    if (key === 'isAccepting') {
      this.onChangeAccepting.emit({ int: data, e: accept });
    } else if (key === 'isAutoAccepting') {
      this.onChangeAutoAccepting.emit({ int: data, e: accept });
    } else if (key === 'isOwnDriver') {
      this.onOwnDriverChange.emit({ int: data, e: accept });
    } else {
      this.onChangeSchedule.emit({ int: data, e: accept });
    }
  }

  onOpen(text: any, id: any) {
    this.open.emit({ text, id });
  }

  getRefreshFilters() {
    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }
  }

  selectAll() {
    this.checkboxSelector.emit();
  }

  onSelectItem(item, event) {
    this.selectItem.emit({ item, event });
  }

  placeTestOrder(data) {
    this.placeTestOrders.emit({ data });
  }

  selectPrepTime(time: any, platformData: any) {
    this.onPrepTimeSelect.emit({ time, platformData })
  }

  onClickBrandAction(type: any, data) {
    switch (type) {
      case 'View':
        this.onViewClick.emit(data);
        break;
      case 'Edit':
        this.onEditClick.emit(data);
        break;
      case 'Delete':
        this.onDeleteClick.emit(data);
        break;
      case 'setUp':
        this.onSetUpClick.emit(data);
        break;
      case 'ViewBtn':
        this.onViewClick.emit(data);
        break;
      case 'Duplicate':
        this.onDuplicateClick.emit(data);
        break;      
      case 'GenerateBtn':
        this.onGenerateClick.emit(data);
        break;

      default:
        break;
    }
  }

  bookingActionBtn(type: any, data: any) {
    console.log(type, data);

    this.onReservationActionClick.emit({ status: type, data: data })
  }
}
